<div [formGroup]="datePickerForm" class="container" [class.reduced-form]="showDateTimeOnly">
    <mat-form-field>
        <mat-label>{{ placeholder }}</mat-label>
        <input
            matInput
            autocomplete="off"
            formControlName="date"
            [disabled]="isDisabled"
            [matDatepicker]="picker"
            (dateChange)="onDateChange($event)"
        />
        <mat-datepicker-toggle tabindex="-1" matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
    <mat-form-field>
        <mat-label>Time</mat-label>
        <input
            matInput
            autocomplete="off"
            type="time"
            formControlName="time"
            [attr.disabled]="isDisabled ? true : null"
            (change)="onTimeChange()"
        />
    </mat-form-field>
    @if(!showDateTimeOnly) {
    <span class="timezone">{{ timezone }}</span>
    <mat-form-field>
        <mat-label>Epoch</mat-label>
        <input
            matInput
            autocomplete="off"
            type="number"
            formControlName="epoch"
            [attr.disabled]="isDisabled ? true : null"
            (change)="onEpochChange($event)"
        />
    </mat-form-field>
    }
</div>
